<template>
  <section class="py-0">

    <aside class="bg-primary bg-gradient rounded-3 p-0 p-sm-1 mt-1">
      <div
          class="d-flex align-items-center justify-content-between flex-column flex-xl-row text-center text-xl-start">
        <div class="mb-4 mb-xl-0">
          <div class="fs-3 fw-bold text-white">Carga Masiva</div>
          <div class="text-white-50">En ésta sección podrás cargar y modificar datos de los empleados por medio de una
            carga de un Excel.
          </div>
        </div>
        <div class="ms-xl-4">
          <div class="input-group mb-2">

            <div v-if="registrosCargaExito != null" class="container">
              <div class="row">

                <div class="col-12 mb-3" style="text-align: right">
                  <span class="badge btn-success">{{ uploadedFile.name }} ({{ uploadedFile.size }})</span>
                </div>

                <div class="col-3">
                  <button type="button" class="btn btn-sm btn-primary position-relative m-l-1" @click="void(0);">Pendientes
                    <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                      {{ registrosCargaExito.filter(x => x.stCarga === 1).length }}
                    </span>
                  </button>
                </div>
                <div class="col-3">
                  <button type="button" class="btn btn-sm btn-warning position-relative m-l-1" @click="void(0);">Procesando
                    <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                      {{ registrosCargaExito.filter(x => x.stCarga === 2).length }}
                    </span>
                  </button>
                </div>
                <div class="col-3">
                  <button type="button" class="btn btn-sm btn-success position-relative m-l-1" @click="void(0);">Cargado
                    <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                      {{ registrosCargaExito.filter(x => x.stCarga === 3).length }}
                    </span>
                  </button>
                </div>
                <div class="col-3">
                  <button type="button" class="btn btn-sm btn-danger position-relative m-l-1" @click="void(0);">Error
                    <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                      {{ registrosCargaExito.filter(x => x.stCarga === -1).length }}
                    </span>
                  </button>
                </div>
              </div>

            </div>

          </div>

          <div class="container" >
            <div class="row">

              <div class="col-12" v-if="registrosCargaExito == null">

                <download-excel :data="xlsExportTemplate" type="xlsx"
                                :export-fields="fieldsXLSTemplate"
                                class="btn btn-success btn m-2"
                                name="Template carga empleados" worksheet="Carga de empleados"
                                title="Descargar archivo XLSX con los datos del prueba"
                >
                  <FontAwesomeIcon :icon="faDownload()"/> Template
                </download-excel>

                <button type="button" class="btn btn-success"
                        :disabled="registrosCargaExito != null && registrosPendientesProcesar()"
                        @click="$refs.file.click()">
                  <FontAwesomeIcon :icon="faUpload()"/>
                  Seleccionar XLSX
                </button>
                <input style="display:none" class="form-control" type="file" @change="uploadFile" ref="file"
                       id="formFile"
                       accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel">


              </div>

            </div>
          </div>

        </div>
      </div>
    </aside>

    <div class="alert alert-warning" role="alert" v-if="registrosCargaExito != null">
      <div v-if="!procesando && registrosCargaExito.filter(x => x.stCarga===1).length">

        <div class="row">
          <div class="col-6">
            Verifique la información antes de realizar la carga...
          </div>
          <div class="col-6" style="text-align:right">
            <button type="button" class="btn btn-danger"
                    @click="cancelarCarga()">
              <FontAwesomeIcon :icon="faStop()"/> Cancelar Carga
            </button>

            <button type="button" class="btn btn-primary m-1"
                    @click="iniciarCarga" ref="btnProcesar">
              <FontAwesomeIcon :icon="faPlay()"/> Iniciar Carga
            </button>
          </div>
        </div>
      </div>
      <div v-if="registrosCargaExito != null">
        <span v-if="registrosCargaExito.filter(x => x.stCarga === 1 || x.stCarga === 2).length > 0">
          No cierre o cambie esta ventana hasta que termine todo el proceso (Procesos por finalizar:
          {{ registrosCargaExito.filter(x => x.stCarga === 1 || x.stCarga === 2).length }})
        </span>
        <span v-else>
          <button type="button" class="btn btn-success"
                  @click="cancelarCarga()">
              <FontAwesomeIcon :icon="faRedo()"/> Limpiar e iniciar otra Carga
            </button>
        </span>
      </div>

    </div>

    <div class="alert alert-danger" role="alert" v-if="registrosCargaError != null && registrosCargaError.length>0">
      Los siguientes registros tienen algún error y no serán cargados:
      <ul>
        <li v-for="er in registrosCargaError" :key="er">
          {{er.numEmpleado}} - {{er.nombreEmpleado}} - {{er.turno}} - {{er.cliente}} - {{er.sucursal}}
        </li>
      </ul>
    </div>

    <aside class="bg-gradient rounded-3 p-0 p-sm-1 mt-1">
      <div class="table-responsive">
        <table class="table table-striped table-hover" id="table-dash">
          <thead>
          <tr>
            <th scope="col">Número de empleado</th>
            <th scope="col">Nombre</th>
            <th scope="col">Turno</th>
            <th scope="col">Cliente</th>
            <th scope="col">Sucursal</th>
            <th scope="col">Estatus</th>
          </tr>
          </thead>
          <tbody>
          <template v-if="registrosCargaExito != null">
            <template v-for="row in registrosCargaExito" :key="row">
              <tr>
                <template v-for="(cel, name) in row" :key="cel">
                  <td>
                    <template v-if="name==='stCarga'">
                      <template v-if="cel===1">
                        <span class="badge bg-primary">Pendiente</span>
                      </template>
                      <template v-if="cel===2">
                      <span class="badge bg-warning text-dark">
                        <div class="spinner-border text-primary spinner-border-sm" role="status"/>
                        Procesando
                      </span>
                      </template>
                      <template v-if="cel===3">
                        <span class="badge bg-success">Cargado</span>
                      </template>
                      <template v-if="cel===-1">
                        <span class="badge bg-danger">Error</span>
                      </template>
                    </template>
                    <template v-else>
                      {{ cel }}
                    </template>
                  </td>
                </template>
              </tr>
            </template>
          </template>
          <tr v-else>
            <td colspan="13" style="text-align: center;"><h6>SIN DATOS PARA CARGAR</h6></td>
          </tr>
          </tbody>
        </table>
      </div>
    </aside>

  </section>

</template>

<script>
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import {faDownload, faPlay, faRedo, faStop, faUpload} from "@fortawesome/free-solid-svg-icons";
import {inject} from "vue";
import {CargaMasivaService} from "@/services/CargaMasivaService";
import readXlsxFile, {readSheetNames} from 'read-excel-file'

export default {
  name: 'CargaMasiva-Component',
  inject: ['$axios', '$localStorageService'],
  components: {FontAwesomeIcon},
  setup() {
    return {
      srv_cargaMasivaService: new CargaMasivaService(inject('$axios'))
    }
  },
  data() {
    return {
      procesando: false,
      uploadedFile: null,
      registrosCargaExito: null,
      registrosCargaError: null,
      schema: {
        'N. Empleado': {
          prop: 'numEmpleado',
          type: Number
        },
        'Nombre': {
          prop: 'nombreEmpleado',
          type: String
        },
        'Turno': {
          prop: 'turno',
          type: String
        },
        'Cliente': {
          prop: 'cliente',
          type: String
        },
        'Sucursal': {
          prop: 'sucursal',
          type: String
        },
      },
      fieldsXLSTemplate: {
        'N. Empleado': '0',
        'Nombre': '1',
        'Turno': '2',
        'Cliente': '3',
        'Sucursal': '4'
      },
      xlsExportTemplate: [
        {
          "0": 1,
          "1": "Pedro Prueba",
          "2": "01-cli",
          "3": "Sabritas",
          "4": "Centro",
        }
      ]
    }
  },
  created() {
    // this.moment = moment;
  },
  async mounted() {


  },
  methods: {
    faDownload() {
      return faDownload;
    },
    faUpload() {
      return faUpload;
    },
    faRedo() {
      return faRedo;
    },
    faPlay() {
      return faPlay;
    },
    faStop() {
      return faStop;
    },
    async uploadFile() {

      await this.cancelarCarga();

      try {
        this.uploadedFile = this.$refs.file.files[0];
        this.registrosCargaExito = [];
        this.registrosCargaError = [];

        const schema =this.schema;

        readSheetNames(this.uploadedFile).then((sheetNames) => {
          sheetNames.forEach(sheetN => {
            readXlsxFile(this.uploadedFile, {schema, sheet: sheetN}).then((rows) => {
              // console.info(rows.rows);
              // console.info(rows.errors);

              rows.rows.forEach(row => {

                if (row.numEmpleado != null && row.numEmpleado !== ''
                    && row.nombreEmpleado != null && row.nombreEmpleado !== ''
                    && row.turno != null && row.turno !== ''
                    && row.cliente != null && row.cliente !== ''
                    && row.sucursal != null && row.sucursal !== '') {
                  this.registrosCargaExito.push({
                    numEmpleado: row.numEmpleado,
                    nombreEmpleado: row.nombreEmpleado,
                    turno: row.turno,
                    cliente: row.cliente,
                    sucursal: row.sucursal,
                    stCarga: 1
                  });
                } else {
                  this.registrosCargaError.push({
                    numEmpleado: row.numEmpleado,
                    nombreEmpleado: row.nombreEmpleado,
                    turno: row.turno,
                    cliente: row.cliente,
                    sucursal: row.sucursal,
                    stCarga: 1
                  });
                }
              })

              // this.registrosCargaExito.push(...rows.rows)
              // this.registrosCargaError.push(...rows.errors)

            })
          })

        })
      } catch (e) {

        this.registrosCargaExito = null;
        this.registrosCargaError = null;

        this.$swal.fire({
          icon: "error",
          text: 'Ocurrio un problema al leer el archivo excel'
        });

      }
    },

    registrosPendientesProcesar() {
      return this.registrosCargaExito != null
          && this.registrosCargaExito.some(r => r.stCarga === 1 || r.stCarga === 2)
    },

    async cancelarCarga() {
      this.procesando = false;
      this.uploadedFile = false;
      this.registrosCargaExito = null;
      this.registrosCargaError = null;
    },

    async iniciarCarga() {

      this.procesando = true;

      const regPendientes = this.registrosCargaExito.filter(x => x.stCarga === 1);

      console.info(".....procesando pendientes {} {}", regPendientes.length, this.registrosCargaExito.filter(x => x.stCarga === 2).length)


      if (regPendientes.length > 0
          && this.registrosCargaExito.filter(x => x.stCarga === 2).length === 0) {

        for (let i = 0; i < regPendientes.length; i++) {
          const reg = regPendientes[i];
          reg.stCarga = 2;

          await this.srv_cargaMasivaService.cargarAltaPacientes(reg.nombreEmpleado, reg.numEmpleado,
              String(reg.numEmpleado), reg.cliente, reg.sucursal, reg.turno)
              .then(() => {
                regPendientes[i].stCarga = 3;
              }).catch((error) => {
            regPendientes[i].stCarga = -1;
            console.error(error)
          })
        }

      } else {
        return false;
      }


    },


  },
  filters: {},

};
</script>

